import * as React from "react";
import { Box, Button, Grid, Typography } from "@mui/material";

export default function FactOrOpinion({ question, onAnswer = () => {} }) {
    const questions = question.questionList || [];
    const [answer, setAnswer] = React.useState(
		Array(questions.length).fill("")
	);

	React.useEffect(() => {
        // reset proceed button
        setAnswer(Array(questions.length).fill(""));
	}, [question, questions.length]);

	const handleSetAnswer = (choice, i) => {
		let ans = [...answer];
		ans[i] = choice;
		setAnswer(ans);

		const canProceed =
			ans.filter((a) => a !== "").length === questions.length;

		onAnswer({
			canProceed,
			answer: ans,
		});
	};
	return (
		<React.Fragment>
				<Box className="choices-container">
                    <Box sx={{ px: {xs: 2, sm: 6}, py: 4}}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold'}} >{question.questionTitle}</Typography>
                        <Typography>{question.questionSubtitle}</Typography>
                    </Box>
					{questions.map((q, i) => (
						<Box
							sx={{ mt: 3 }}
							key={`question-${i}-${Math.random()}`}
						>
							<Grid container justifyContent="center">
								<Grid item sm={12} sx={{ textAlign: "left", px: {xs: 2, sm: 5} }}>
									<Typography variant="qlist_text">
										{q.text}
									</Typography>
								</Grid>
							</Grid>
							<Grid
								container
								gap={1}
								justifyContent="center"
								sx={{ mt: 1 }}
							>
								{q.choices.map((choice, j) => (
									<Grid
										item
										sm={5}
										xs={5}
										key={`choices-${j}-${Math.random()}`}
									>
										<Button
											variant={
												answer[i] === choice.value
													? "contained"
													: "outlined"
											}
											fullWidth
                                            onClick={() => handleSetAnswer(choice.value, i)}
											size="large"
											sx={{ fontSize: "1.2rem", px: 1 }}
										>
											{choice.label}
										</Button>
									</Grid>
								))}
							</Grid>
						</Box>
					))}
				</Box>

		</React.Fragment>
	);
}
